export default __webpack_public_path__ + "static/stepsImage-1c9dab63f3798ee47f18f4f0d381e744.webp";